export enum Services {
  Create = 'create',
  Edit = 'edit',
  Delete = 'delete',
}
